import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Speed,
  Loyalty,
  TouchApp,
  CreditCard,
  ExpandMore,
  CheckCircle,
  WhatsApp,
  BarChart,
  LocalShipping,
  Timer,
  QrCode2,
  MenuBook,
  Restaurant,
  Campaign,
  TwoWheeler,
  Storefront,
  ArrowForward
} from '@mui/icons-material';

class FazPedidoModuloCatalogoPage extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: '#ffffff', color: '#0f172a', minHeight: '100vh', pb: 10 }}>

        {/* 1. HERO SECTION */}
        <Box
          sx={{
            bgcolor: '#ffffff',
            pt: { xs: 8, md: 12 },
            pb: { xs: 8, md: 10 },
            borderBottom: '1px solid #f1f5f9'
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Chip
                  label="Tecnologia FazPedido"
                  sx={{
                    bgcolor: 'rgba(124, 58, 237, 0.1)',
                    color: '#7c3aed',
                    fontWeight: 700,
                    mb: 2,
                    px: 1
                  }}
                />
                <Typography
                  variant="h2"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '2.2rem', md: '3.4rem' },
                    lineHeight: 1.2,
                    color: '#0f172a',
                    mb: 2
                  }}
                >
                  Seu delivery e restaurante merece o melhor{' '}
                  <Box component="span" sx={{ color: '#7c3aed' }}>
                    Cardápio Digital!
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: '#64748b', fontWeight: 400, mb: 4, lineHeight: 1.6 }}
                >
                  Chega de erros nos pedidos e de perder vendas por demora no atendimento! Com o FazPedido, você tem uma solução completa que agiliza os pedidos, melhora a experiência do cliente e aumenta seu faturamento.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      px: 4,
                      py: 1.8,
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      borderRadius: '12px',
                      textTransform: 'none',
                      boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.3)'
                    }}
                  >
                    Testar FazPedido Grátis
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      color: '#7c3aed',
                      borderColor: '#7c3aed',
                      '&:hover': { borderColor: '#6d28d9', bgcolor: 'rgba(124, 58, 237, 0.04)' },
                      px: 3,
                      py: 1.8,
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 700
                    }}
                  >
                    Ver Demonstração
                  </Button>
                </Stack>
              </Grid>

              {/* DEMO CARD PREVIEW */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#f8fafc',
                    borderRadius: '24px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 20px 30px -10px rgba(124, 58, 237, 0.15)'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 48, height: 48 }}>
                      <Storefront />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        FazPedido Demo
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        pedidos.fazpedido.com.br/sualoja
                      </Typography>
                    </Box>
                  </Box>

                  <Card variant="outlined" sx={{ mb: 2, borderRadius: '14px', borderColor: '#e2e8f0' }}>
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          Pedido #4092 - Combo Sushibar
                        </Typography>
                        <Chip label="Recebido no PDV" size="small" sx={{ bgcolor: 'rgba(124, 58, 237, 0.15)', color: '#7c3aed', fontWeight: 700 }} />
                      </Stack>
                      <Typography variant="h6" sx={{ color: '#7c3aed', fontWeight: 800, mt: 1 }}>
                        R$ 119,90
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Pagamento Automático via PIX • Impresso na Cozinha
                      </Typography>
                    </CardContent>
                  </Card>

                  <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                        Veja como é o Cardápio Digital mais completo do Brasil na prática!
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* 2. OS 4 PILARES DO CARDÁPIO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={3}>
            {[
              {
                num: '01',
                title: 'Carregamento Rápido',
                desc: 'Não tenha problemas com a demora no carregamento do cardápio. Alta velocidade no celular ou desktop.',
                icon: <Speed sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '02',
                title: 'Programa de Fidelidade Integrado',
                desc: 'Atraia, retenha e fidelize seus clientes com facilidade criando pontos e prêmios automáticos.',
                icon: <Loyalty sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '03',
                title: 'Design Intuitivo',
                desc: 'Fácil de navegar, o que resulta em uma melhor experiência para o usuário e aumento do ticket médio.',
                icon: <TouchApp sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '04',
                title: 'Pagamento Online',
                desc: 'Segurança e praticidade na hora de fechar a compra com integração nativa de pagamentos.',
                icon: <CreditCard sx={{ color: '#7c3aed', fontSize: 32 }} />
              }
            ].map((pillar, idx) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#7c3aed',
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 20px -5px rgba(124, 58, 237, 0.1)'
                    }
                  }}
                >
                  <Typography variant="h3" sx={{ fontWeight: 900, color: 'rgba(124, 58, 237, 0.2)', position: 'absolute', top: 16, right: 16 }}>
                    {pillar.num}
                  </Typography>
                  <Box sx={{ mb: 2 }}>{pillar.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {pillar.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                    {pillar.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 3. AUTOMAÇÃO PARA DELIVERY */}
        <Container maxWidth="lg" sx={{ mt: 12 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              bgcolor: '#f8fafc',
              border: '1px solid #e2e8f0'
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                  Automatize as vendas do seu delivery com o nosso Cardápio Digital
                </Typography>
                <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                  Dê autonomia aos seus clientes para pedirem seus pratos favoritos com facilidade e rapidez, diretamente de casa!
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                  O FazPedido é uma solução completa com chatbot para delivery, integração com pagamentos online, agendamento de pedidos e muito mais! Tudo isso te permite economizar tempo e aumentar a eficiência do seu negócio.
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { title: 'Relatórios de Vendas', desc: 'Acompanhe os resultados em tempo real e melhore suas estratégias.', icon: <BarChart /> },
                    { title: 'Pagamento Online', desc: 'Simplifique o processo de compra com opções de pagamento digital seguras.', icon: <CreditCard /> },
                    { title: 'Gestão de Rotas e Entregas', desc: 'Organize e monitore suas entregas para garantir mais agilidade.', icon: <LocalShipping /> },
                    { title: 'Atendimento Rápido e Eficiente', desc: 'Reduza o tempo de espera dos seus clientes e melhore a experiência de compra.', icon: <Timer /> }
                  ].map((item, i) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={i}>
                      <Stack direction="row" spacing={1.5} alignItems="flex-start">
                        <Avatar sx={{ bgcolor: '#7c3aed', width: 36, height: 36, mt: 0.5 }}>
                          {React.cloneElement(item.icon, { sx: { fontSize: 20, color: '#fff' } })}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0f172a' }}>
                            {item.title}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b', display: 'block', lineHeight: 1.4 }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    bgcolor: '#ffffff',
                    p: 4,
                    borderRadius: '20px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 15px 30px -10px rgba(124, 58, 237, 0.12)'
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#7c3aed', mb: 2 }}>
                    Fluxo Automático FazPedido
                  </Typography>
                  <List disablePadding>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Cliente acessa o link e faz o pedido em segundos" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Pagamento aprovado via PIX ou Cartão" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Impressão automática no balcão e na cozinha" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Notificação de status enviada ao WhatsApp do cliente" />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* 4. CARDÁPIO DIGITAL DE MESA */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={4} alignItems="center">
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  bgcolor: '#7c3aed',
                  color: '#ffffff',
                  borderRadius: '24px',
                  boxShadow: '0 20px 40px -10px rgba(124, 58, 237, 0.4)'
                }}
              >
                <QrCode2 sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>
                  QR Code para Mesas
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9, mb: 3 }}>
                  Elimine a espera por atendentes! O cliente senta na mesa, lê o QR Code, escolhe o pedido e realiza o pagamento diretamente pelo próprio celular.
                </Typography>
                <Chip label="Ideal para Restaurantes, Sushibars e Bares" sx={{ bgcolor: '#ffffff', color: '#7c3aed', fontWeight: 700 }} />
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                Ofereça praticidade aos seus clientes com nosso Cardápio Digital de mesa!
              </Typography>
              <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                Transforme a experiência dos seus clientes ao oferecer um Cardápio Digital em todas as mesas do seu estabelecimento. Com mais autonomia e praticidade, seus clientes poderão visualizar os itens do cardápio, fazer seus pedidos e pagar com facilidade.
              </Typography>

              <Stack spacing={2}>
                {[
                  { title: 'QR Code para Mesa', desc: 'Simples e rápido, seus clientes acessam o cardápio diretamente pelo celular.' },
                  { title: 'Cardápio Sempre Disponível', desc: 'O cardápio está sempre ao alcance dos clientes, sem necessidade de esperar.' },
                  { title: 'Fotos e Descrição', desc: 'Seus clientes podem ver fotos de todos os pratos, além da descrição de todos os itens.' },
                  { title: 'Facilidade na Escolha', desc: 'Com poucos cliques, navegue por todos os itens fazendo os pedidos de forma rápida.' }
                ].map((feat, idx) => (
                  <Paper key={idx} elevation={0} sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#7c3aed' }}>
                      {feat.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64748b' }}>
                      {feat.desc}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
              <Typography variant="subtitle2" sx={{ mt: 3, fontWeight: 700, color: '#0f172a' }}>
                Não perca a oportunidade de transformar clientes esporádicos em clientes fiéis.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        {/* 5. CARDÁPIO NO BALCÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              bgcolor: '#ffffff',
              border: '2px solid #f1f5f9'
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                  Tenha um Cardápio Digital no balcão do seu estabelecimento e não perca vendas
                </Typography>
                <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                  Aumente a eficiência do seu atendimento com um Cardápio Digital de balcão. Ofereça aos seus clientes autonomia para escolher e pagar de forma fácil, sem filas ou complicações.
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { title: 'Fácil Acesso', desc: 'O cliente consulta o cardápio sem depender do atendimento presencial.' },
                    { title: 'Fim das Filas', desc: 'Agilize o atendimento e evite clientes insatisfeitos com grandes filas.' },
                    { title: 'Autonomia para Pedidos', desc: 'Liberdade total para os clientes escolherem os pratos e adicionais.' },
                    { title: 'Facilidade no Pagamento', desc: 'Ofereça opções de pagamento direto pelo cardápio digital no balcão.' }
                  ].map((balcao, index) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={index}>
                      <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', height: '100%' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#7c3aed', mb: 0.5 }}>
                          {balcao.title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>
                          {balcao.desc}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#f8fafc',
                    borderRadius: '20px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center'
                  }}
                >
                  <Storefront sx={{ fontSize: 60, color: '#7c3aed', mb: 2 }} />
                  <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 1 }}>
                    PDV & Balcão Sincronizados
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Todos os pedidos feitos no balcão ou tablet são lançados no seu painel de caixa do FazPedido em tempo real.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* 6. ESPECIALIZAÇÃO PARA SUSHIBARS E SEGMENTOS */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              O Melhor Cardápio Digital para o seu Sushibar e Gastronomia
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b', mt: 1 }}>
              Automatize o atendimento, personalize a experiência e incentive a lealdade dos seus clientes.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <WhatsApp sx={{ fontSize: 40, color: '#7c3aed' }} />,
                title: 'Automação de WhatsApp para Delivery',
                desc: 'Facilite o atendimento e agilize os pedidos com automação de mensagens via WhatsApp de forma transparente.'
              },
              {
                icon: <Restaurant sx={{ fontSize: 40, color: '#7c3aed' }} />,
                title: 'CRM para Sushibar & Restaurantes',
                desc: 'Organize dados de clientes, personalize o atendimento e otimize a retenção com a nossa ferramenta de CRM integrada.'
              },
              {
                icon: <Loyalty sx={{ fontSize: 40, color: '#7c3aed' }} />,
                title: 'Programa de Fidelidade Exclusivo',
                desc: 'Ofereça recompensas exclusivas, pontos por compras e incentivos para que seus clientes voltem a pedir com mais frequência.'
              }
            ].map((sushi, sIdx) => (
              <Grid size={{ xs: 12, md: 4 }} key={sIdx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    borderRadius: '20px',
                    bgcolor: '#ffffff',
                    border: '2px solid #7c3aed',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 15px 30px -10px rgba(124, 58, 237, 0.2)'
                    }
                  }}
                >
                  <Box sx={{ mb: 2 }}>{sushi.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {sushi.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                    {sushi.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 7. RECURSOS ADICIONAIS */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Conheça o que mais o FazPedido pode fazer por você!
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                icon: <Campaign sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Campanhas de WhatsApp para Restaurante',
                desc: 'Aumente suas vendas enviando promoções e cupons diretamente pelo WhatsApp do seu cliente de forma automática!'
              },
              {
                icon: <TwoWheeler sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Gestão de Entregadores para Restaurante',
                desc: 'Gerencie rotas e entregas do seu delivery, garantindo mais agilidade com controle eficiente de motoboys e mapa de calor.'
              },
              {
                icon: <MenuBook sx={{ fontSize: 32, color: '#7c3aed' }} />,
                title: 'Cardápio Digital para Mesas',
                desc: 'Facilite pedidos com QR codes, permitindo que clientes acessem o cardápio e façam pedidos direto pelo celular sem esperar.'
              }
            ].map((extra, eIdx) => (
              <Grid size={{ xs: 12, md: 4 }} key={eIdx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0'
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>{extra.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {extra.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    {extra.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 8. SEÇÃO DE PROVA SOCIAL / CLIENTES */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Veja quem já utiliza nosso Cardápio Digital!
            </Typography>
          </Box>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            {['Sushibar Express', 'Burger House', 'Pizzaria Bella', 'Padaria Central', 'Doceria Gourmet'].map((brand, bIdx) => (
              <Grid size={{ xs: 6, sm: 4, md: 2.4 }} key={bIdx}>
                <Paper
                  elevation={0}
                  sx={{
                    py: 2,
                    px: 3,
                    textAlign: 'center',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px'
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#64748b' }}>
                    {brand}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 9. FAQ / PERGUNTAS FREQUENTES */}
        <Container maxWidth="md" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 1.5 }}>
              DÚVIDAS FREQUENTES
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Ficou com dúvidas?
            </Typography>
          </Box>

          {[
            {
              q: '1. Qual valor eu pago para usar o sistema?',
              a: 'Os valores podem variar dependendo do plano que melhor se encaixa nas suas necessidades para a sua loja. Nossos planos têm valores acessíveis e flexíveis. Entre em contato com um de nossos especialistas para apresentar o plano ideal para seu negócio.'
            },
            {
              q: '2. Como faço para cadastrar meu cardápio físico no sistema do Cardápio Digital?',
              a: 'O cadastro é extremamente intuitivo! Nossa equipe auxilia no processo inicial ou você pode importar categorias, produtos, fotos e adicionais rapidamente pelo painel administrativo.'
            },
            {
              q: '3. É possível ter um Cardápio Digital e usar outras plataformas, como o iFood?',
              a: 'Sim! Você pode utilizar o Cardápio Digital do FazPedido para receber vendas diretas com 0% de taxa sobre o pedido, mantendo paralelamente outros canais de venda.'
            },
            {
              q: '4. O Cardápio Digital é a mesma coisa que um cardápio em PDF?',
              a: 'Não. O Cardápio Digital do FazPedido é um sistema web interativo onde o cliente monta o pedido, escolhe adicionais, efetua o pagamento online e manda o pedido já pronto direto para sua cozinha e PDV.'
            }
          ].map((faq, fIdx) => (
            <Accordion
              key={fIdx}
              elevation={0}
              sx={{
                mb: 1.5,
                border: '1px solid #e2e8f0',
                borderRadius: '12px !important',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { border: '1px solid #7c3aed' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#7c3aed' }} />}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>

        {/* 10. BANNER FINAL DE CONVERSÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '28px',
              p: { xs: 5, md: 8 },
              textAlign: 'center',
              border: '3px solid #7c3aed',
              boxShadow: '0 20px 40px -15px rgba(124, 58, 237, 0.25)'
            }}
          >
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Chegou a hora de automatizar o seu atendimento!
            </Typography>
            <Typography variant="h6" sx={{ color: '#64748b', mb: 4, maxW: '650px', mx: 'auto', fontWeight: 400 }}>
              Comece a usar o FazPedido e veja a diferença! Fale com um dos nossos especialistas e teste a plataforma gratuitamente.
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              sx={{
                bgcolor: '#7c3aed',
                color: '#ffffff',
                '&:hover': { bgcolor: '#6d28d9' },
                px: 5,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 800,
                borderRadius: '14px',
                textTransform: 'none',
                boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.4)'
              }}
            >
              Falar com um Especialista
            </Button>
          </Paper>
        </Container>

      </Box>
    );
  }
}

export default FazPedidoModuloCatalogoPage;